module.exports = __webpack_public_path__ + "img/1024.396c3cfa.svg";